import React from 'react';

// Ícones de linha finos e suaves (stroke = currentColor, herdam a cor do item).
const base = {
  width: 22,
  height: 22,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
};

export const HomeIcon = () => (
  <svg {...base}><path d="M3 10.5 12 3l9 7.5" /><path d="M5.5 9.5V20h13V9.5" /><path d="M10 20v-5h4v5" /></svg>
);

export const DumbbellIcon = () => (
  <svg {...base}><path d="M6.5 7v10M17.5 7v10M4 9.5v5M20 9.5v5M6.5 12h11" /></svg>
);

export const MailIcon = () => (
  <svg {...base}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="m3.5 7 8.5 6 8.5-6" /></svg>
);

export const NotebookIcon = () => (
  <svg {...base}><rect x="5" y="3" width="14" height="18" rx="2" /><path d="M9 3v18" /><path d="M12.5 8h4M12.5 12h4" /></svg>
);

export const CalendarIcon = () => (
  <svg {...base}><rect x="3" y="5" width="18" height="16" rx="2" /><path d="M3 10h18M8 3v4M16 3v4" /></svg>
);

export const NewsIcon = () => (
  <svg {...base}><rect x="4" y="5" width="16" height="14" rx="2" /><path d="M8 9h8M8 12.5h8M8 16h5" /></svg>
);

export const MonitorIcon = () => (
  <svg {...base}><rect x="3" y="4" width="18" height="12" rx="2" /><path d="M8 20h8M12 16v4" /></svg>
);

export const TasksIcon = () => (
  <svg {...base}><path d="M10 6h9M10 12h9M10 18h9" /><path d="m3.5 6 1.2 1.2L7 5" /><path d="m3.5 12 1.2 1.2L7 11" /><path d="m3.5 18 1.2 1.2L7 17" /></svg>
);

export const CompareIcon = () => (
  <svg {...base}><path d="M4 20V10M10 20V4M16 20v-7M22 20H2" /></svg>
);

export const HeartIcon = () => (
  <svg {...base}><path d="M12 20s-7.5-4.7-10-9.4C.5 7.2 2.3 4 5.6 4c1.9 0 3.4 1 4.4 2.4C11 5 12.5 4 14.4 4c3.3 0 5.1 3.2 3.6 6.6C19.5 15.3 12 20 12 20Z" /></svg>
);

export const BookIcon = () => (
  <svg {...base}><path d="M4 5.5C4 4.7 4.7 4 5.5 4H12v16H5.5C4.7 20 4 19.3 4 18.5v-13Z" /><path d="M20 5.5c0-.8-.7-1.5-1.5-1.5H12v16h6.5c.8 0 1.5-.7 1.5-1.5v-13Z" /></svg>
);

export const UtensilsIcon = () => (
  <svg {...base}>
    <path d="M7 2v8M9.5 2v8M12 2v8" />
    <path d="M9.5 10v12" />
    <path d="M17 2c-1.7 0-3 2-3 5s1.3 5 3 5v10" />
  </svg>
);

export const SettingsIcon = () => (
  <svg {...base}><circle cx="12" cy="12" r="3.2" /><path d="M12 3v2.2M12 18.8V21M4.2 7.5l1.9 1.1M17.9 15.4l1.9 1.1M3 12h2.2M18.8 12H21M4.2 16.5l1.9-1.1M17.9 8.6l1.9-1.1" /></svg>
);

export const UsersIcon = () => (
  <svg {...base}><circle cx="9" cy="8" r="3" /><path d="M3.5 20c0-3 2.5-5.5 5.5-5.5s5.5 2.5 5.5 5.5" /><circle cx="17" cy="9" r="2.3" /><path d="M15.5 14.3c2.3.4 4 2.4 4 4.7" /></svg>
);

export const WalletIcon = () => (
  <svg {...base}><path d="M3 7.5C3 6.1 4.1 5 5.5 5h12A1.5 1.5 0 0 1 19 6.5V8" /><rect x="3" y="8" width="18" height="12" rx="2" /><path d="M15.5 14.3a1.3 1.3 0 1 0 0-2.6 1.3 1.3 0 0 0 0 2.6Z" /></svg>
);

export const FlaskIcon = () => (
  <svg {...base}><path d="M10 3h4M10 3v6.5L4.8 18a1.6 1.6 0 0 0 1.4 2.4h11.6a1.6 1.6 0 0 0 1.4-2.4L14 9.5V3" /><path d="M7.5 15h9" /></svg>
);

export const MoonIcon = () => (
  <svg {...base}><path d="M20 14.2A8.5 8.5 0 1 1 9.8 4a7 7 0 0 0 10.2 10.2Z" /></svg>
);

export const PulseIcon = () => (
  <svg {...base}><path d="M2.5 12h4l2-6.5 4 13 2-8.5 1.5 2h5.5" /></svg>
);

// Glifo sólido (não é linha como os outros) — igual ao símbolo de "IA" já
// consagrado em apps grandes (Gemini/Copilot etc.), reconhecível de cara.
export const SparkleIcon = () => (
  <svg width={22} height={22} viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2c.5 5 1 7.5 3.5 8.5C18 11.5 20 12 22 12c-2 0-4 .5-6.5 1.5C13 14.5 12.5 17 12 22c-.5-5-1-7.5-3.5-8.5C6 12.5 4 12 2 12c2 0 4-.5 6.5-1.5C11 9.5 11.5 7 12 2Z" />
  </svg>
);

export const ScaleIcon = () => (
  <svg {...base}><rect x="3.5" y="3.5" width="17" height="17" rx="4" /><circle cx="12" cy="12" r="2" /><path d="M12 6.5v2M17.5 12h-2M12 17.5v-2M6.5 12h2" /></svg>
);

// Glifo colorido do Instagram (gradiente da marca) — usado nos cards de
// conexão/métricas, não é um ícone de linha como os outros (é reconhecível
// só com a cor certa).
export const InstagramGlyph = ({ size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={{ verticalAlign: '-3px' }}>
    <defs>
      <linearGradient id="ig-grad" x1="0" y1="24" x2="24" y2="0">
        <stop offset="0%" stopColor="#FEDA75" />
        <stop offset="25%" stopColor="#FA7E1E" />
        <stop offset="50%" stopColor="#D62976" />
        <stop offset="75%" stopColor="#962FBF" />
        <stop offset="100%" stopColor="#4F5BD5" />
      </linearGradient>
    </defs>
    <rect x="2.5" y="2.5" width="19" height="19" rx="5.5" fill="none" stroke="url(#ig-grad)" strokeWidth="1.8" />
    <circle cx="12" cy="12" r="4.6" fill="none" stroke="url(#ig-grad)" strokeWidth="1.8" />
    <circle cx="17.3" cy="6.7" r="1.15" fill="url(#ig-grad)" />
  </svg>
);

export const LogoutIcon = () => (
  <svg {...base}><path d="M9 4H5.5A1.5 1.5 0 0 0 4 5.5v13A1.5 1.5 0 0 0 5.5 20H9" /><path d="M15 16l4-4-4-4" /><path d="M19 12H9" /></svg>
);
